function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, Object, String, fetchedDataGroups, selected) {
    var h = require("panel").h;
    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "class": Object.assign({}, {
          'mp-data-group-selector-theme-builder': $attr(`theme`) === `builder`,
          'mp-data-group-selector-theme-default': !$attr(`theme`),
          'mp-data-group-selector-is-loaded': fetchedDataGroups,
        }, {
          'mp-data-group-selector-container': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-data-group-selector-label': true
          },
        }, [__vjadeSafeCode($attr(`label`))]));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-data-group-selector-select-wrapper': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((!fetchedDataGroups) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-spinner"));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-select", {
              "attrs": {
                theme: $attr(`theme`) === `builder` ? `builder` : `builder-light`,
                sections: JSON.stringify($helpers.getDataGroupsList()),
                'selected-option': selected.displayName,
                'menu-width': 270,
              },
              "on": {
                change: $helpers.clickDataGroupOption
              },
            }));;
            return __jade_nodes
          }).call(this)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(($attr(`label-right`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-data-group-selector-label-right': true
            },
          }, [__vjadeSafeCode($attr(`label-right`))]));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat(h("mp-toast-area", {
          "hook": {
            insert: $helpers.toastAreaInserted
          },
        }));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "fetchedDataGroups" in locals ? locals.fetchedDataGroups : typeof fetchedDataGroups !== "undefined" ? fetchedDataGroups : undefined, "selected" in locals ? locals.selected : typeof selected !== "undefined" ? selected : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;